import * as THREE from 'three'

export default function buildModifiedMaterial(uniforms){  
  const modifiedMaterial = new THREE.MeshStandardMaterial({
    transparent: true
  })
    
  modifiedMaterial.onBeforeCompile = (shader) => {
    // Uniforms
    shader.uniforms.uTime = uniforms.uTime
    shader.uniforms.uSpeed = uniforms.uSpeed
    shader.uniforms.uFrequency = uniforms.uFrequency
    shader.uniforms.uAmplitude = uniforms.uAmplitude

    shader.uniforms.uOffsetX = uniforms.uOffsetX
    shader.uniforms.uOffsetZ = uniforms.uOffsetZ

    shader.uniforms.uColor1 = uniforms.uColor1
    shader.uniforms.uColor2 = uniforms.uColor2
    shader.uniforms.uColor3 = uniforms.uColor3
    shader.uniforms.uColor4 = uniforms.uColor4
    shader.uniforms.uEnd1 = uniforms.uEnd1
    shader.uniforms.uEnd2 = uniforms.uEnd2
    shader.uniforms.uEnd3 = uniforms.uEnd3

    shader.vertexShader = shader.vertexShader.replace(
      '#include <common>', 
      `
      #include <common>
      
      float random(vec2 n) { 
        return fract(sin(dot(n, vec2(12.9898, 4.1414))) * 43758.5453);
      }
      
      float noise2(vec2 p){
        vec2 ip = floor(p);
        vec2 u = fract(p);
        u = u*u*(3.0-2.0*u);
        
        float res = mix(
          mix(random(ip),random(ip+vec2(1.0,0.0)),u.x),
          mix(random(ip+vec2(0.0,1.0)),random(ip+vec2(1.0,1.0)),u.x),u.y);
        return res*res;
      }

      // END PERLIN NOISE

      uniform float uTime;
      uniform float uSpeed;
      uniform float uFrequency;
      uniform float uAmplitude;
      uniform float uOffsetX;
      uniform float uOffsetZ;

      varying float vHeight;

      attribute vec2 aPos;
      `
    )
    shader.vertexShader = shader.vertexShader.replace(
      '#include <begin_vertex>',
      `
        #include <begin_vertex>
        
        // Apply Speed
        float timer = uTime * uSpeed;  

        // Apply Noise
        vec2 posWithOffset = aPos.xy;
        posWithOffset.x += uOffsetX;
        posWithOffset.y += uOffsetZ;
        vHeight = noise2(posWithOffset.xy * uFrequency + timer) * uAmplitude;
        
        transformed.y += vHeight;

        transformed.x += uOffsetX;
        transformed.z += uOffsetZ;
      `
    )
    shader.fragmentShader = shader.fragmentShader.replace(
      '#include <common>',
      `
        #include <common>
        
        varying float vHeight;

        uniform vec3 uColor1;
        uniform vec3 uColor2;
        uniform vec3 uColor3;
        uniform vec3 uColor4;

        uniform float uEnd1;
        uniform float uEnd2;
        uniform float uEnd3;

        uniform float uAmplitude;
      `
    ),
    shader.fragmentShader = shader.fragmentShader.replace(
      'vec4 diffuseColor = vec4( diffuse, opacity );',
      `
        float hightValue = vHeight / uAmplitude;

        vec3 color = uColor4;
        
        if(hightValue < uEnd1){
          color = uColor1;
        }
        else if(hightValue < uEnd2){
          color = uColor2;
        }
        else if(hightValue < uEnd3){
          color = uColor3;
        }
      
        vec4 diffuseColor = vec4(color, opacity);
      `
    )
  }

  return modifiedMaterial
}
